import gql from 'graphql-tag'

export const USER = gql`
  query user {
    me {
      id
      email
      firstname
      lastname
      isEmailVerified
      permissions {
        id
        projectId
        projectName
        role
      }
    }
  }
`

export const ALL_CUSTOMER = gql`
  query allCustomer($projectId: ID!, $limit: Int) {
    customers(projectId: $projectId, limit: $limit) {
      id
      uuid
      name
      platform
      isHumanTakingOver
      status
      pictureUrl
      lastMessage {
        id
        data {
          type
          value
        }
        createdAt
      }
      unSeenMessageAfterTakingOver
    }
  }
`

export const CHATLOGS = gql`
  query chatlogs($projectId: ID!, $customerId: ID!, $offset: Int) {
    messageLog(
      projectId: $projectId
      customerId: $customerId
      offset: $offset
    ) {
      messages {
        id
        source
        data {
          type
          value
        }
        messageUUID
        sentiment
        customerId
        customerPlatformUUID
        createdAt
        consoleDetail {
          firstname
          lastname
          id
          email
        }
      }
      hasNextPage
    }
  }
`

export const MEMBERS = gql`
  query members($projectId: ID!) {
    members(projectId: $projectId) {
      id
      role
      email
      isEnableNotification
      lineName
      userId
    }
  }
`

export const PRODUCT_FOR_EDIT_CUSTOMER_CART_QUERY = gql`
  query activeProduct($projectId: ID!, $productId: ID!) {
    activeProduct(projectId: $projectId, productId: $productId) {
      id
      name
      brand
      categories {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        inventory
        reserved
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        isFree
        image {
          src
        }
      }
    }
  }
`

export const PRODUCT_FOR_DIALOG_QUERY = gql`
  query product($projectId: ID!, $id: ID!) {
    product(projectId: $projectId, id: $id) {
      id
      name
      brand
      categoriesV2 {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        isFree
        deleted
        selected
        image {
          src
        }
      }
    }
  }
`

export const PRODUCTS = gql`
  query products($projectId: ID!) {
    products(projectId: $projectId) {
      id
      name
      brand
      categories {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        image {
          src
        }
      }
    }
  }
`

export const ACTIVE_PRODUCTS = gql`
  query activeProducts($projectId: ID!) {
    activeProducts(projectId: $projectId) {
      id
      name
      brand
      categories {
        id
        category
      }
      properties {
        id
        name
        value
      }
      images {
        src
      }
      description
      defaultPrice
      isCustomSKU
      productCode
      productSKUs {
        id
        price
        productCode
        productType {
          id
          value
          key {
            id
            key
          }
        }
        deleted
        selected
        isFree
        image {
          src
        }
      }
    }
  }
`

export const CUSTOMER_CART = gql`
  query cart($projectId: ID!, $customerId: ID!) {
    cart(projectId: $projectId, customerId: $customerId) {
      items {
        productId
        productSKUId
        amount
        isFree
      }
    }
  }
`

export const STORE = gql`
  query store($projectId: ID!) {
    store(projectId: $projectId)
  }
`

export const GET_FAQ = gql`
  query getFAQ($projectId: ID!) {
    getFAQ(projectId: $projectId) {
      name
      questions
      response {
        type
        value
      }
    }
  }
`

export const GET_PAYMENT = gql`
  query($projectId: ID!) {
    payment(projectId: $projectId) {
      bankAccounts {
        bankName
        accountName
        accountNo
        branch
      }
      promptPay {
        accountName
        accountNo
      }
    }
  }
`
export const GET_SHOP = gql`
  query($projectId: ID!) {
    shopDetail(projectId: $projectId) {
      image
      general {
        name
        address {
          address_1
          address_2
          district
          subDistrict
          province
          postcode
          branch
        }
        phoneNumber
      }
      socialMedia {
        facebook
        instagram
        twitter
        website
      }
    }
  }
`

export const GET_GREETING_MESSAGES = gql`
  query greetingMessage($projectId: ID!) {
    greetingMessage(projectId: $projectId) {
      type
      value
    }
  }
`

export const GET_DEFAULT_SHIPPING_METHOD = gql`
  query defaultShippingMethod($projectId: ID!) {
    defaultShippingMethod(projectId: $projectId) {
      method
      calculateType
      pricePerUnit
      minimumPrice
      maximumPrice
      fixedPrice
      minDuration
      maxDuration
      description
      disabled
    }
  }
`

export const GET_RESPONSE_MESSAGE = gql`
  query getResponseMessage($projectId: ID!) {
    getResponseMessage(projectId: $projectId) {
      name
      variable {
        key
        example
      }
      defaultMessage {
        type
        value
      }
      customMessage {
        type
        value
      }
    }
  }
`

export const GET_PROJECT = gql`
  query getProject($projectId: ID!) {
    getProject(projectId: $projectId) {
      facebookPageId
      facebookPageName
      facebookPageToken
    }
  }
`

export const GET_ALL_STORE_SETTING_DATA = gql`
  query getAllStoreSettingData($projectId: ID!) {
    shopDetail(projectId: $projectId) {
      image
      general {
        name
        address {
          address_1
          address_2
          district
          subDistrict
          province
          postcode
          branch
        }
        phoneNumber
      }
      socialMedia {
        facebook
        instagram
        twitter
        website
      }
    }

    payment(projectId: $projectId) {
      bankAccounts {
        bankName
        accountName
        accountNo
        branch
        accountType
      }
      promptPay {
        accountName
        accountNo
      }
    }

    vat(projectId: $projectId) {
      vatOptions
      vatPercentage
      vatId
      isShowTaxInfo
    }

    greetingMessage(projectId: $projectId) {
      type
      value
    }
  }
`
export const SEARCH_PRODUCTS_BY_PRODUCT_CODE = gql`
  query searchSKUs(
    $projectId: ID!
    $searchQuery: String
    $offset: Int
    $limit: Int
    $isFree: Boolean
  ) {
    searchSKUs(
      projectId: $projectId
      searchQuery: $searchQuery
      offset: $offset
      limit: $limit
      isFree: $isFree
    ) {
      id
      productCode
      price
      image {
        src
      }
      selected
      deleted
      productType {
        value
        key {
          key
        }
      }
      createdAt
      updatedAt
      productName
      productId
      productImages {
        src
      }
    }
  }
`

export const GET_SHIPPING_PROMOTION_BY_PROJECT_ID = gql`
  query getShippingPromotionByProjectId($projectId: ID!) {
    getShippingPromotionByProjectId(projectId: $projectId) {
      id
      name
      description
      isActive
      groupType
      discountType
      amount
      shippingMethod
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_PRODUCT_PROMOTION_BY_PROJECT_ID = gql`
  query getProductPromotionByProjectId($projectId: ID!) {
    getProductPromotionByProjectId(projectId: $projectId) {
      id
      name
      description
      isActive
      type
      promotionDetails {
        by
        rule
        type
        amount
        price
        buyCondition
        getValue
        productId
        skuId
        skuDetail {
          id
          productId
          productCode
          productType {
            id
            value
            key {
              id
              key
            }
          }
          productName
          productImages {
            src
          }
          image {
            src
          }
        }
      }
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_SHIPPING_METHOD_BY_PROJECT_ID = gql`
  query getShippingMethodByProjectId($projectId: ID!) {
    getShippingMethodByProjectId(projectId: $projectId) {
      id
      method
      calculateType
      pricePerUnit
      minimumPrice
      fixedPrice
      minDuration
      maxDuration
      description
      productSKUs {
        id
        product {
          name
        }
        productCode
        price
        image {
          src
        }
        selected
        deleted
        productType {
          id
          value
          key {
            id
            key
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_BOT_TIMER = gql`
  query botTimer($projectId: ID!) {
    getBotTimer(projectId: $projectId) {
      isOpen
      timeToResume
    }
  }
`

export const GET_SEARCH_PRODUCTS_ORDER = gql`
  query getSearchProductsOrder($projectId: ID!) {
    getSearchProductsOrder(projectId: $projectId)
  }
`

export const BOT_GENDER = gql`
  query getBotGender($projectId: ID!) {
    getProject(projectId: $projectId) {
      id
      botGender
    }
  }
`

export const MESSAGE_USAGE = gql`
  query getMessageUsage($projectId: ID!) {
    getProject(projectId: $projectId) {
      currentMonthlyMessageUsage
      monthlyMessageQuota
    }
  }
`

export const EXPORT_ORDER = gql`
  query exportOrder(
    $projectId: ID!
    $startDate: String
    $endDate: String
    $orderState: OrderState
  ) {
    exportOrder(
      projectId: $projectId
      startDate: $startDate
      endDate: $endDate
      orderState: $orderState
    ) {
      orderNumber
      state
      shippingMethod
      shippingPrice
      shippingDuration
      customerName
      address
      phoneNumber
      note
      email
      trackingNumber
      vatOptions
      totalPrice
      discountTotalPrice
      grandTotal
      paymentBillImageSrc
      paymentAt
      bill {
        billNumber
      }
      products {
        productCode
        productPrice
        amount
        image {
          src
        }
        productType {
          value
          key {
            key
          }
        }
        product {
          id
          name
          productCode
        }
      }
    }
  }
`

export const ALL_CATEGORY = gql`
  query allCategory(
    $projectId: ID!
    $offset: Int
    $limit: Int
    $filter: CategoryFilterInput
  ) {
    categories(
      projectId: $projectId
      offset: $offset
      limit: $limit
      filter: $filter
    ) {
      results {
        id
        projectId
        name
        image
        isActive
        properties {
          name
        }
        variations {
          name
        }
      }
      total
    }
  }
`

export const GET_FAQ_TRAIN_JOB_OPERATION = gql`
  query getFAQTrainJobOperation($projectId: ID!) {
    faqTrainJobOperation(projectId: $projectId) {
      id
      status
      timestamp
    }
  }
`

export const VAT = gql`
  query vatV2($projectId: ID!) {
    vat: vatV2(projectId: $projectId) {
      id
      projectId
      taxId
      option
      isShowTaxInfo
      rate
      companyName
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/query.js